import { BarChart3, GraduationCap, Users2 } from 'lucide-react';
import { usePublicSiteContent } from '../../services/public-queries';
import { Skeleton } from '../components/Skeleton';
import { CountUp } from '../components/motion';

/**
 * The figures are typed in by an editor (Nội dung trang), never counted from
 * the database: counting members live would mean a public endpoint touching
 * the members table, which is precisely the boundary the public surface is
 * built to avoid. Each position keeps its own icon.
 */
const STAT_ICONS = [Users2, GraduationCap, BarChart3];

export function About() {
  const { content } = usePublicSiteContent();
  return (
    <section id="about" className="mx-auto w-full max-w-[1328px] scroll-mt-20 px-4 py-16 md:px-6 md:py-24">
      <div className="grid gap-10 md:grid-cols-2 md:items-center">
        <div>
          <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-brand-700 dark:text-brand-400">Về chúng tôi</p>
          <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl lg:text-[42px] lg:leading-[1.15] dark:text-white">
            HBAC là gì?
          </h2>
          <div className="mt-5 space-y-4 text-base leading-relaxed text-slate-600 md:text-[17px] dark:text-slate-300">
            <p>
              <strong className="text-slate-800 dark:text-slate-100">HUST Business Analytics Club</strong> là câu lạc bộ
              học thuật trực thuộc Đại học Bách khoa Hà Nội, quy tụ những sinh viên quan tâm tới phân tích kinh doanh,
              dữ liệu và công nghệ.
            </p>
            <p>
              Chúng tôi tin rằng dữ liệu chỉ có giá trị khi trở thành quyết định. Vì vậy mọi hoạt động của CLB đều xoay
              quanh việc <em>làm thật</em>: từ workshop, dự án cộng đồng tới các cuộc thi phân tích quy mô toàn quốc.
            </p>
          </div>

          <div className="mt-8 grid grid-cols-3 gap-4" data-testid="about-stats">
            {content
              ? content.about.stats.map((s, i) => {
                  const Icon = STAT_ICONS[i] ?? BarChart3;
                  return (
                    <div key={i}>
                      <Icon size={18} className="text-brand-500" />
                      <p className="mt-2 font-display text-2xl font-extrabold text-slate-900 dark:text-white">
                        <CountUp value={s.value} />
                      </p>
                      <p className="text-xs text-slate-500 dark:text-slate-400">{s.label}</p>
                    </div>
                  );
                })
              : STAT_ICONS.map((_, i) => <Skeleton key={i} className="h-20" />)}
          </div>
        </div>

        <div data-reveal className="overflow-hidden rounded-3xl shadow-xl ring-1 ring-slate-200 dark:ring-navy-700">
          <img src="/logo/cover.webp" alt="Hoạt động của CLB HBAC" width={1200} height={457} loading="lazy" decoding="async" className="h-auto w-full object-cover" />
        </div>
      </div>
    </section>
  );
}
